// extracted by mini-css-extract-plugin
export default {"author":"Author-module--author--1c58d","author__bio-twitter":"Author-module--author__bio-twitter--75212"};